import type { ComponentType } from 'react';

import { Icon, type IconName } from '../Icon.tsx';
import { EmptyState, PageHeader } from '../ui.tsx';

/**
 * A page the shell navigates to before the story that builds it lands.
 *
 * The shell, its shortcuts and its five destinations are one story (this one);
 * what each destination shows is a story of its own. Rather than leave a
 * shortcut pointing at nothing, every entry point exists from the start and
 * says which story fills it in — so a broken link is always a bug, never a
 * roadmap item.
 */
export function placeholder(options: {
  readonly title: string;
  readonly icon: IconName;
  readonly story: string;
  readonly summary: string;
}): ComponentType {
  function Placeholder() {
    return (
      <div className="page">
        <PageHeader title={options.title} />
        <EmptyState icon={options.icon} title={`${options.title} is not built yet`}>
          <p>{options.summary}</p>
          <p className="muted">
            <Icon name="list" /> {options.story}
          </p>
        </EmptyState>
      </div>
    );
  }
  Placeholder.displayName = `Placeholder(${options.title})`;
  return Placeholder;
}
